import { useCallback } from 'react';
import { SET_SHIPPING_METHOD } from '../queries/cart';
import useCartMutation from './useCartMutation';

const useSetShippingMethod = () => {
  const [mutation, { loading, error: shippingMethodError }] = useCartMutation(SET_SHIPPING_METHOD);

  const setShippingMethod = useCallback(
    method => {
      return mutation({
        variables: {
          input: {
            shipping_methods: [{ ...method }],
          },
        },
      });
    },
    [mutation],
  );

  return {
    setShippingMethod,
    loading,
    shippingMethodError,
  };
};

export default useSetShippingMethod;
